import { render, staticRenderFns } from "./morningPaperIndexSet.vue?vue&type=template&id=1087fa2a&scoped=true&"
import script from "./morningPaperIndexSet.vue?vue&type=script&lang=js&"
export * from "./morningPaperIndexSet.vue?vue&type=script&lang=js&"
import style0 from "./morningPaperIndexSet.vue?vue&type=style&index=0&id=1087fa2a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1087fa2a",
  null
  
)

export default component.exports